import React, { useEffect, useState } from "react";
import { navigate } from "@reach/router";
import { getTemplateById } from "../../../actions/RFQ/templateAction";
import { useSelector } from "react-redux";
import { showToast } from "utils/helpers";
import CreateRFQPage from "../RFQ/CreateRFQ/CreateRFQPage/CreateRFQPage";
import { LoadingSpinner } from "components/Loading/LoadingSpinner";

type ProtectedTemplateRouteProps = {
	templateId: string;
	isEdit?: boolean;
	isTemplate?: boolean;
};

export const ProtectedTemplateRoute = ({
	templateId,
	isEdit = false,
	isTemplate = false,
}: ProtectedTemplateRouteProps) => {
	const [isLoading, setIsLoading] = useState(true);
	const [isAuthorized, setIsAuthorized] = useState(false);
	const { current_company } = useSelector((state: any) => state.auth);
	const companyId = current_company?.id;

	useEffect(() => {
		const checkTemplateAccess = async () => {
			try {
				const template = await getTemplateById(parseInt(templateId));

				if (!template) {
					showToast("Template not found", "Error");
					navigate(`/account/${companyId}/manage-templates`);
					return;
				}

				// Check if template is locked and user is trying to edit
				if (isEdit && template.status === "locked") {
					showToast("Cannot edit locked template", "Access Denied");
					navigate(`/account/${companyId}/manage-templates`);
					return;
				}

				setIsAuthorized(true);
			} catch (error) {
				console.error("Template access check failed:", error);
				showToast("Failed to verify template access", "Error");
				navigate(`/account/${companyId}/manage-templates`);
			} finally {
				setIsLoading(false);
			}
		};

		if (templateId) {
			checkTemplateAccess();
		}
	}, [templateId, isEdit, companyId]);

	if (isLoading) {
		return (
			<div className="flex h-[50vh] items-center justify-center">
				<LoadingSpinner />
			</div>
		);
	}

	if (!isAuthorized) {
		return null; // Navigation already handled in useEffect
	}

	return (
		<CreateRFQPage
			rfqId={null}
			isEdit={isEdit}
			isTemplate={isTemplate}
			templateId={templateId}
		/>
	);
};
